<template>
  <div class="game">
    <Levo />
    <GameControls />
    <router-view name="gameView" />
    <GameSplashScreen />

    <!-- Pouzivam pro preloadni obrazku, ktery jsou v css jako background image a jejich nacitani pak zpusobovalo probliknuti -->
    <div id="preload">
      <img src="@/assets/images/svg/menu_items/editProducts-active.svg" />
      <img src="@/assets/images/svg/menu_items/gameOverview-active.svg" />
      <img src="@/assets/images/svg/menu_items/purchaseData-active.svg" />
      <img src="@/assets/images/svg/menu_items/setCampaigns-active.svg" />
      <img src="@/assets/images/svg/menu_items/setCampaigns-active.svg" />
      <img src="@/assets/images/svg/next_round/clock_arrow.svg" />
      <img src="@/assets/images/svg/next_round/clock_base.svg" />
      <img src="@/assets/images/svg/next_round/clock_button.svg" />
      <img src="@/assets/images/svg/next_round/lady.svg" />
      <img src="@/assets/images/svg/next_round/money.svg" />
      <img src="@/assets/images/svg/finalScreen/stuhy.svg" />
    </div>
  </div>
</template>

<script>
import Levo from "@/components/game/Levo.vue";
import GameControls from "@/components/game/GameControls.vue";
import FinalScreen from "@/components/game/FinalScreen.vue";
import GameSplashScreen from "@/components/game/GameSplashScreen.vue";

export default {
  name: "Game",
  components: {
    Levo,
    GameControls,
    GameSplashScreen,
  },
  data: function () {
    return {
      nextRoundClicked: false,
    };
  },
  async mounted() {
    await this.$store.dispatch("loadActiveGame");
  },
};
</script>
